<div class="mc-spring-board">
  <div class="mc-spring-board-header">
    <p class="mc-license-connectors-settings-breadcrumb-wrapper">
      <button type="button" class="mc-inline-button mc-license-connectors-settings-breadcrumb-link" (click)="cancel.emit()">
        Connectors
      </button>

      &nbsp;
      <mat-icon fontSet="project-titan" class="mc-yet-another-centered-text-icon mc-license-connectors-settings-breadcrumb-arrow" fontIcon="icon-right-arrow-90"></mat-icon>
      &nbsp;

      <span class="mc-license-connectors-settings-breadcrumb-title">
        {{ connector ? 'Edit ' : 'New ' }}Connector
      </span>

      <mat-form-field class="mc-form-field mc-form-field-custom-input mc-form-field-compact" mcColor="secondary">
        <mat-label>Type</mat-label>
        <mat-select #typeSelect [disabled]="connector">
          <mat-select-trigger>
            <div class="mc-form-field-select-trigger-wrapper">
              <img alt="Syndicate Logo" *ngIf="connectorType === ConnectionType.Syndicate" class="mc-form-field-select-option-image" src="assets/images/syndicate-logo.svg">
              <mat-icon *ngIf="connectorType === ConnectionType.SFTP" fontSet="project-titan" fontIcon="icon-sftp" class="mc-form-field-select-trigger-icon"></mat-icon>
              <span class="mc-form-field-select-trigger-icon-label">
                <ng-container *ngIf="connectorType === ConnectionType.Syndicate">
                  Syndicate
                </ng-container>
                <ng-container *ngIf="connectorType === ConnectionType.SFTP">
                  SFTP
                </ng-container>
              </span>
            </div>
          </mat-select-trigger>
          <mat-option [value]="ConnectionType.SFTP">
            <mat-icon fontSet="project-titan" class="mc-self-centered-icon mc-form-field-select-option-icon" fontIcon="icon-sftp"></mat-icon>
            SFTP
          </mat-option>
          <mat-option [value]="ConnectionType.Syndicate">
            <img alt="Syndicate Logo" class="mc-form-field-select-option-image" src="assets/images/syndicate-logo.svg">
            Syndicate
          </mat-option>
        </mat-select>
      </mat-form-field>
    </p>
  </div>

  <div class="mc-spring-board-body">
    <ng-container *ngIf="ConnectionType[connectorType] === undefined">
      <p>Choose a type to view its specific settings.</p>
    </ng-container>

    <mc-sftp-form *ngIf="connectorType === ConnectionType.SFTP" [connector]="connector" [licenseId]="licenseId" [licenseUserId]="licenseUserId" (success)="success.emit()" (cancel)="cancel.emit()" #sftpForm>
    </mc-sftp-form>

    <mc-syndicate-form *ngIf="connectorType === ConnectionType.Syndicate" [connector]="connector" [licenseId]="licenseId" [licenseUserId]="licenseUserId" (success)="success.emit()" (cancel)="cancel.emit()" #syndicateForm>
    </mc-syndicate-form>
  </div>
</div>